// Copyright (C) 2017-2023 Smart code 203358507

const Stream = require('./Stream');

module.exports = Stream;
